'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

var _themeCurrency = require('@shopify/theme-currency');

var currency = _interopRequireWildcard(_themeCurrency);

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

var _responsiveImageSwap = require('./responsiveImageSwap');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shopCurrency = (0, _jquery2.default)('body').attr('data-shop-currency');

var init = exports.init = function init() {
  bindUIActions();
};

//Update Cart
var update = function update() {
  cart.getState().then(function (cart) {
    //Update Cart Count Icon
    var $cartTotal = (0, _jquery2.default)(_dom2.default.cartTotal);
    var itemCount = cart.item_count;
    if (itemCount == 0) {
      $cartTotal.removeClass('has-items');
    }
    $cartTotal.text(itemCount);

    //Update Summary
    var price = currency.formatMoney(cart.original_total_price, "${{amount}} " + shopCurrency);
    (0, _jquery2.default)(_dom2.default.cartSummarySubtotal).text(price);
    (0, _jquery2.default)(_dom2.default.cartSummaryTotal).text(price);

    var i = void 0;
    for (i = 0; i < cart.items.length; i++) {
      var productKey = cart.items[i].key;
      var qty = cart.items[i].quantity;
      (0, _jquery2.default)(_dom2.default.lineItem + '[data-key="' + productKey + '"]').find(_dom2.default.qtyInput).val(qty);
    }
  });
};

//check if cart is empty
var emptyCartCheck = function emptyCartCheck(current, cart) {
  (0, _jquery2.default)(current).closest(_dom2.default.lineItem).remove();

  if (cart.item_count === 0) {
    //Refresh page to empty state
    _jquery2.default.get('/cart?view=contents').then(function (response) {
      var $cartContainer = (0, _jquery2.default)(_dom2.default.cartContainer);
      $cartContainer.html(response);
      (0, _responsiveImageSwap.imageSwap)();
    });
    (0, _jquery2.default)(_dom2.default.cartTotal).removeClass('has-items');
    (0, _jquery2.default)(_dom2.default.cartTotal).text(cart.item_count);
  } else {
    update();
    (0, _jquery2.default)(current).closest(_dom2.default.lineItem).remove();
  }
};

//Get Line Item Key
var getLineItemKey = function getLineItemKey(current, key) {
  var lineitem = (0, _jquery2.default)(current).closest(_dom2.default.lineItem);
  if (!key) {
    key = lineitem.data('key');
  }
  return key;
};

//Update QTY
var quantityAdjust = function quantityAdjust(current) {
  var qtyInput = (0, _jquery2.default)(current).closest(_dom2.default.qty).find(_dom2.default.qtyInput);
  var qty = parseInt(qtyInput.val());

  if ((0, _jquery2.default)(current).attr('data-quantity-minus') != undefined) {
    qty = qty - 1;
    if (qty <= 0) {
      qty = 0;
      /*
      setTimeout(function(){
        location.reload();
      }, 500);
      */
    }
  } else {
    qty = qty + 1;
  }

  qtyInput.val(qty).trigger('change');
};

var quantityUpdate = function quantityUpdate(current) {
  var qty = parseInt((0, _jquery2.default)(current).val());

  if (qty > 0) {
    updateLineItem(current, qty);
  } else {
    removeLineItem(current);
  }
};

//Update Line Item
var updateLineItem = function updateLineItem(current, quantity, properties) {
  var key = getLineItemKey(current);
  var customFinishKey = getCustomFinish(current);
  var customFinishAddonKey = getCustomFinishAddon(current);

  if (customFinishKey != undefined) {
    var customFinishQty = (0, _jquery2.default)('[data-key="' + customFinishKey + '"]').attr('data-inventory-count');

    if (quantity > customFinishQty) {
      quantity = parseInt(customFinishQty);
      alert('Not enough inventory to complete request');
    }

    cart.updateItem(key, { quantity: quantity, properties: properties }).then(function (cart) {
      updateCustomFinishLineItem(customFinishKey, quantity, customFinishAddonKey);
    });
  } else {
    cart.updateItem(key, { quantity: quantity, properties: properties }).then(function (cart) {
      update();
    });
  }
};

//Remove Line Item
var removeLineItem = function removeLineItem(current) {
  var key = getLineItemKey(current);
  var customFinishKey = getCustomFinish(current);
  var addonKey = getAddon(current);
  var customFinishAddonKey = getCustomFinishAddon(current);

  cart.removeItem(key).then(function (cart) {
    if (customFinishKey != undefined) {
      removeCustomFinishLineItem(customFinishKey, current, customFinishAddonKey);
    } else if (addonKey != undefined) {
      removeAddonLineItem(addonKey, current);
    } else {
      emptyCartCheck(current, cart);
    }
  });
};

var bindUIActions = function bindUIActions() {
  //Update QTY
  (0, _jquery2.default)(document).on('click', _dom2.default.qtyAdjust, function () {
    quantityAdjust(this);
  });

  (0, _jquery2.default)(document).on('blur, change', _dom2.default.qtyInput, function () {
    quantityUpdate(this);
  });

  //Remove Line Item
  (0, _jquery2.default)(document).on('click', _dom2.default.lineItemRemoveTrigger, function () {
    removeLineItem(this);
  });
};

//****************
// CUSTOM FINISH
//****************

var getCustomFinish = function getCustomFinish(current, customFinishKey) {
  var $current = (0, _jquery2.default)(current).closest(_dom2.default.lineItem);
  var currentProdHandle = $current.attr('data-product-handle');
  var currentVariantId = $current.attr('data-variant-id');
  var customFinishId = $current.find(_dom2.default.lineItemCustomFinishId).attr('data-property-value');
  var customFinish = (0, _jquery2.default)(_dom2.default.customFinishLineItem + '[data-variant-id="' + customFinishId + '"][data-poster-product-handle="' + currentProdHandle + '"][data-poster-variant-id="' + currentVariantId + '"]');

  if (!customFinishKey) {
    customFinishKey = customFinish.data('key');
  }
  return customFinishKey;
};

var getCustomFinishAddon = function getCustomFinishAddon(current, customFinishAddonKey) {
  var $current = (0, _jquery2.default)(current).closest(_dom2.default.lineItem);
  var currentProdHandle = $current.attr('data-product-handle');
  var currentVariantId = $current.attr('data-variant-id');
  var customFinishId = $current.find(_dom2.default.lineItemCustomFinishId).attr('data-property-value');
  var customFinishAddonId = $current.find('[data-line-item-custom-finish-addon-id]').attr('data-property-value');
  var customFinishAddon = (0, _jquery2.default)(_dom2.default.customFinishLineItem + '[data-variant-id="' + customFinishAddonId + '"][data-poster-product-handle="' + currentProdHandle + '"][data-poster-variant-id="' + currentVariantId + '"][data-frame-id="' + customFinishId + '"');

  if (!customFinishAddonKey) {
    customFinishAddonKey = customFinishAddon.data('key');
  }
  return customFinishAddonKey;;
};

var updateCustomFinishLineItem = function updateCustomFinishLineItem(customFinishKey, quantity, customFinishAddonKey) {
  if (customFinishAddonKey != undefined) {
    var customFinishAddonQty = (0, _jquery2.default)('[data-key="' + customFinishAddonKey + '"]').attr('data-inventory-count');

    if (quantity > customFinishAddonQty) {
      quantity = parseInt(customFinishAddonQty);
      alert('Not enough inventory to complete request');
    }

    cart.updateItem(customFinishKey, { quantity: quantity, properties: {} }).then(function (cart) {
      updateCustomFinishAddonLineItem(customFinishAddonKey, quantity);
    });
  } else {
    cart.updateItem(customFinishKey, { quantity: quantity, properties: {} }).then(function (cart) {
      update();
    });
  }
};

var updateCustomFinishAddonLineItem = function updateCustomFinishAddonLineItem(customFinishAddonKey, quantity) {
  cart.updateItem(customFinishAddonKey, { quantity: quantity, properties: {} }).then(function (cart) {
    update();
  });
};

var removeCustomFinishLineItem = function removeCustomFinishLineItem(customFinishKey, current, customFinishAddonKey) {
  cart.removeItem(customFinishKey).then(function (cart) {
    if (customFinishAddonKey != undefined) {
      removeCustomFinishAddonLineItem(customFinishAddonKey, current);
    } else {
      emptyCartCheck(current, cart);
    }
  });
};

var removeCustomFinishAddonLineItem = function removeCustomFinishAddonLineItem(customFinishAddonKey, current) {
  cart.removeItem(customFinishAddonKey).then(function (cart) {
    emptyCartCheck(current, cart);
  });
};

//****************
// Addon
//****************

var getAddon = function getAddon(current, addonKey) {
  var addonLineItem = (0, _jquery2.default)(current).closest(_dom2.default.lineItem).find(_dom2.default.addonLineItem);

  if (!addonKey) {
    addonKey = addonLineItem.data('key');
  }
  return addonKey;
};

var removeAddonLineItem = function removeAddonLineItem(addonKey, current) {
  cart.removeItem(addonKey).then(function (cart) {
    emptyCartCheck(current, cart);
  });
};